import { render, staticRenderFns } from "./telemetry-status-display.vue?vue&type=template&id=2c5d60c7&scoped=true"
import script from "./telemetry-status-display.vue?vue&type=script&lang=ts&setup=true"
export * from "./telemetry-status-display.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./telemetry-status-display.vue?vue&type=style&index=0&id=2c5d60c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d60c7",
  null
  
)

export default component.exports